import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    paginationModel: {pageNumber: 0, pageSize: 20}
};

export const paginationSlice = createSlice({
    name: 'pagination',
    initialState,
    reducers: {
        setPaginationModel: (state, action) => {
            state.paginationModel = action.payload;
        },
        // back to the first page; a page may keep its own page size (the Profiles page uses 20, 40 and 80)
        resetPaginationState: (state, action) => {
            state.paginationModel = {
                pageNumber: 0,
                pageSize: action?.payload?.pageSize ?? initialState.paginationModel.pageSize
            };
        },
    }
});

export const {setPaginationModel, resetPaginationState} = paginationSlice.actions;

export default paginationSlice.reducer;
